import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface Tab {
  name: string;
  hide?: boolean;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {
  @Input() isActive = 0;
  @Input() noBorder = false;
  @Input() tabs: Tab[];
  @Input() sharedTranslate = false;
  @Output() activated = new EventEmitter<number>();
}
